import upperFirst from 'lodash/upperFirst'
import { formatUserName } from './formatUserName'
import { User } from './types'

export const getCommentAuthorName = ({
  user,
  integration,
  includeInactiveTag = false,
}: {
  user: (Pick<User, 'firstName' | 'lastName'> & { isArchived?: boolean }) | null
  integration?: string
  includeInactiveTag?: boolean
}): string => {
  if (user) {
    const { firstName, lastName, isArchived } = user
    return includeInactiveTag && isArchived !== undefined
      ? formatUserName({ firstName, lastName, isArchived })
      : `${firstName} ${lastName}`
  }
  if (integration) return upperFirst(integration)
  return 'Omnea'
}
